module.exports = __webpack_public_path__ + "static/media/clock-urgent.9e909b73.mp3";